import React from "react";

/**
 * The theme components only imports it's theme CSS-file. These components are lazy
 * loaded, to enable "code splitting" (in order to avoid the themes being bundled together)
 */
const ThemeMobile = React.lazy(() => import("./Theme"));

const ThemeSelector = ({ children }) => (
  <>
    {/* Conditionally render theme, based on the current client context */}
    <React.Suspense fallback={() => null}>
      {window.screen.width < 480 && <ThemeMobile />}
    </React.Suspense>

    {children}
  </>
);

export default ThemeSelector;
